// src/Section/Home/Terravia.jsx

import React from "react";
import Banner from "../../Section/Home/Banner/banner.jsx";
import Desktop from "../../Media/Header/Desktop/DesktopEonna.webp";
import Mobile from "../../Media/Header/Mobile/Mobile_Eonna.webp";
import About from "../../Section/Detail/about/about.jsx";
import Promo from "../../Section/Home/Promo/promo.jsx";
import Lokasi from "../../Section/Home/Lokasi/lokasi.jsx";
import Terraviadata from "./Eonna.json";
import promoData from "./promo.json";
import logo from "./Eonnalogo.png";
import hardsell from "../../Media/Promo/Hardsell_Eonna.webp";
import Aerra from "../Eonna/Aerra/Aerra.jsx";
import Namee from "../Eonna/Namee/Namee.jsx";
import Elyon from "../Eonna/Elyon/Elyon.jsx";
import Fasilitas from "../../Section/Home/Fasilitas/fasilitas.jsx";
import Fasilitasdata from "./fasilitas.json"; // Ensure this path is correct
import Fasilitasimages from "../../Media/Fasilitas BSD/Eonna/Eonnaf.js"; // Ensure this path is correct
import Surrounding from "../../Section/Home/surrounding/Surrounding.jsx";

const Terravia = () => {
  return (
    <div>
      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About
        logo={logo}
        judul={Terraviadata.judul}
        Deskripsi={Terraviadata.deskripsi}
      />
      <Promo
        image={hardsell}
        title={promoData.title}
        points={promoData.points}
        whatsapp={promoData.whatsapp}
      />
      <Elyon />
      <Aerra />
      <Namee />
      <Fasilitas
        title={Fasilitasdata.title}
        description={Fasilitasdata.description}
        facilities={Fasilitasdata.facilities}
        images={Fasilitasimages} // Pass images as a prop
      />
      <Surrounding />

      <Lokasi />
    </div>
  );
};

export default Terravia;
